import { render, staticRenderFns } from "./ProdEditSemiprodChild.vue?vue&type=template&id=4fcf4110&"
import script from "./ProdEditSemiprodChild.vue?vue&type=script&lang=js&"
export * from "./ProdEditSemiprodChild.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditSemiprodChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports